import React, { forwardRef, useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import moment from "moment-jalaali";
import DatePickerComponent from 'Utils/Helpers/DatePickerComponent';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { TextShow } from 'Utils/Helpers/TextShow';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { get_byDate, update_appointment_status } from 'http/components/AppointmentService';
import { enqueueSnackbar } from 'notistack';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import DateCheck from 'Utils/Helpers/DateCheck';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import GetAppointmentType from 'Utils/Helpers/AppointmentType';
import ActionButton from 'Utils/Helpers/ActionButton';
import TimePickerComponent from 'Utils/Helpers/TimePickerComponent';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function StatusEdit({ data, item, close}) {
    const dispatch = useDispatch();
    const { totalTimes, dateSearch, current } = useSelector((state) => ({
        totalTimes: state.setting.totalTimes,
        dateSearch: state.setting.dateSearch,
        current: state.staff.current,
    }));
    const [show, setShow] = useState(false);
    const [time, setTime] = useState(null);
    const [noTimeStatus, setNoTimeStatus] = useState(false);
    const [lastTime, setLastTime] = useState(null);
    const [newDate, setNewDate] = useState(moment(data.date, 'jYYYY/jMM/jDD'));
    const [controls, setControls] = useSetState ({
        description: {
          id: "description",
          type: 'text',
          placeholder: 'توضیحات',
          value: '',
          icon: <icons.ChatDots/>,
        },
    });

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }

    useEffect(() => {
        if(show && totalTimes) {
            if(item.time) {
                try {
                    const H = +item.time.split('/')[0]
                    const M = item.time.split('/')[1] ? `/${item.time.split('/')[1]}` : '/00'
                    setLastTime({H, M, time: `${H.toString().substring(2)}${M.replace('/',':')}`})
                    setTime(`${H}${M}`);
                } catch {
                    setLastTime(null);
                    setTime(`${totalTimes.filter(item => item.status)[0].id}/00`)
                }
            } else {
                if(data.time) {
                    try {
                        const H = +data.time.split('/')[0]
                        const M = data.time.split('/')[1] ? `/${data.time.split('/')[1]}` : '/00'
                        setLastTime({H, M, time: `${H.toString().substring(2)}${M.replace('/',':')}`})
                        setTime(`${H}${M}`);
                        setNoTimeStatus(true);
                    } catch {
                        setLastTime(null);
                        setTime(`${totalTimes.filter(item => item.status)[0].id}/00`)
                    }
                } else {
                    setLastTime(null);
                    setTime(`${totalTimes.filter(item => item.status)[0].id}/00`)
                }
            }
            setControls({ description: { value: item.description } });
        }
    },[show, totalTimes])

    const setShowDialog = () => {
      setShow(true);
    }

    const handleClose= () => {
        setShow(false);
    }

    const handleChangeTime = (e) => {
        setTime(e)
    }

    const onSubmit = async () => {
        let _date = null;
        let _time = null;
        if(item.stid === 4)
            _date = item.date;
        if(item.stid === 1 || item.stid === 2 || item.stid === 3 || item.stid === 6 || item.stid === 7)
            _date = newDate.locale("fa").format("jYYYY/jMM/jDD");
        if(item.stid === 4 || item.stid === 6 || item.stid === 7)
            _time = time;

        if(!_date || DateCheck(_date)) {
            const params = {
                date: _date,
                time: _time,
                description: (controls.description.value && controls.description.value !== '') ? controls.description.value : null,
            }
            const response = await update_appointment_status({data, item, dow: dateSearch.dow, params});
            if(response.status) {
                enqueueSnackbar('وضعیت با موفقیت ویرایش شد', {variant: 'success'});
                const response2 = await get_byDate(dateSearch.date);
                if(response2.status) {
                    await dispatch(SetAppointmentsData(response2.data));
                    handleClose();
                    close();
                } else {
                    dispatch(HandleLoading(false));
                }
            } else {
                dispatch(HandleLoading(false));
            }
        } else {
            enqueueSnackbar('تاریخ انتخاب شده گذشته است', {variant: 'warning'});
            dispatch(HandleLoading(false));
        }
    }

    return (
        <>
            <ActionButton
                icon={<icons.Pencil/>}
                onClick={setShowDialog}
                disabled={!current[1][5]}
                hidden={!current[1][5]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    fullWidth={true}
                    maxWidth={'xs'}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClose}
                    // TransitionProps={{onEnter: onEnter}}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                    <DialogTitle className='edit-mode'>
                        {"ویرایش وضعیت"}
                        <div className='close-btn' onClick={handleClose}>
                            <icons.X/>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {
                            (show && time) &&
                            <DialogContentText id="alert-dialog-slide-appointment-edit">
                                <div className='appointment-edit'>
                                    <div className='patient mb-3'>
                                        <TextShow
                                            title={"تاریخ نوبت :"}
                                            data={item.date}
                                            className={'no-hide text-muted'}
                                        />
                                        {
                                            (lastTime || item.stid === 4) &&
                                            <TextShow
                                                title={"ساعت نوبت :"}
                                                data={noTimeStatus ? 'ساعت نوبت در وضعیت تنظیم نشده است' : lastTime ? lastTime.time : 'ساعت نوبت تنظیم نشده است'}
                                                className={'no-hide text-muted'}
                                                className2={`${!lastTime || noTimeStatus ? 'text-danger' : ''}`}
                                            />
                                        }
                                        <TextShow
                                            title={"وضعیت :"}
                                            data={<GetAppointmentStatus id={item.stid}/>}
                                        />
                                        <TextShow
                                            title={'نوع :'}
                                            data={<GetAppointmentType id={data.type} />}
                                        />
                                        <TextShow
                                            title={'کاربر ایجاد :'}
                                            data={item.creatingUser}
                                        />
                                    </div>
                                    <div style={{height: '45px'}}>
                                        {
                                            item.stid &&
                                            (item.stid === 6 || item.stid === 7)
                                            ? <div className='flex-row-center-center mb-3'>
                                                <DatePickerComponent
                                                    icon={<icons.Calendar3/>}
                                                    value={newDate}
                                                    onChange={(e) => setNewDate(e)}
                                                    className={'ms-1'}
                                                />
                                                <TimePickerComponent
                                                    name={'appointment-time'}
                                                    icon={<icons.ClockFill/>}
                                                    selectedHour={+item.time.split('/')[0]}
                                                    selectedMin={item.time.split('/')[1] ? `/${item.time.split('/')[1]}` : '/00'}
                                                    options={totalTimes.filter(item => item.status)}
                                                    onChange={handleChangeTime}
                                                />
                                                {/* <SelectComponent
                                                    name={'appointment-time'}
                                                    icon={<icons.ClockFill/>}
                                                    selected={+item.time}
                                                    options={totalTimes.filter(i => i.status)}
                                                    onChange={handleChangeTime}
                                                /> */}
                                            </div>
                                            : (item.stid === 1 || item.stid === 2 || item.stid === 3)
                                                ? <div className='change-date'>
                                                    <DatePickerComponent
                                                        icon={<icons.Calendar3/>}
                                                        value={newDate}
                                                        onChange={(e) => setNewDate(e)}
                                                    />
                                                </div>
                                                : (item.stid === 4)
                                                    ? <div className='change-date'>
                                                        <TimePickerComponent
                                                            name={'appointment-time'}
                                                            icon={<icons.ClockFill/>}
                                                            selectedHour={lastTime ? lastTime.H : null}
                                                            selectedMin={lastTime ? lastTime.M : null}
                                                            options={totalTimes.filter(item => item.status)}
                                                            onChange={handleChangeTime}
                                                        />
                                                    </div>
                                                    : <div className='text-center'>
                                                        <small>
                                                            {"در این وضعیت امکان تغییر تاریخ یا زمان نمی‌باشد"}
                                                        </small>
                                                    </div>
                                        }
                                    </div>
                                    <div className='mt-1'>
                                        {
                                            Object.keys(controls).map((key, index) => {
                                                return (
                                                    <Inputer
                                                        key={`inputer_${controls[key].id}`}
                                                        id={controls[key].id}
                                                        type={controls[key].type}
                                                        placeholder={controls[key].placeholder}
                                                        value={controls[key].value}
                                                        setValue={setControlsValue.bind(this)}
                                                        icon={controls[key].icon}
                                                        className={'mb-2'}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </DialogContentText>
                        }
                    </DialogContent>
                    <DialogActions>
                        <CButton
                            text={'ذخیره تغییرات'}
                            icon={<icons.Save2/>}
                            onClick={onSubmit}
                        />
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}